export default __webpack_public_path__ + "static/media/Insight_data_tableau_récap_03.d80696ba.svg";